module.exports = __webpack_public_path__ + "static/react-rgbgame-efb283bde33e01f476f2a7a0da39d55c.png";